import React, { useState } from 'react';

import { Col, Row, Tabs } from 'antd';

import stringres from '../../translations/stringres';
import '../Antd.css';
import OpportunitaAddEdit from './OpportunitaAddEdit';
import OpportunitaAttivitaElenco from './OpportunitaAttivita/OpportunitaAttivitaElenco';

export default function OpportunitaScheda(props) {
    const [idOpportunita, setIdOpportunita] = useState(props.idOpportunita);

    function onPropagate(value) {
        setIdOpportunita(value);
    }

    return (
        <div>
            <Tabs
                type="line"
                defaultActiveKey="1"
                items={[
                    {
                        label: stringres.t('anagraficaoppatt'),
                        key: '1',
                        children: (
                            <Row>
                                <Col flex="50%">
                                    <OpportunitaAddEdit
                                        idOpportunita={idOpportunita}
                                        propagate={onPropagate}
                                    ></OpportunitaAddEdit>
                                </Col>
                                <Col flex="50%">
                                    <OpportunitaAttivitaElenco
                                        idOpportunita={idOpportunita}
                                    ></OpportunitaAttivitaElenco>
                                </Col>
                            </Row>
                        ),
                    },
                    {
                        label: stringres.t('allegati'),
                        key: '2',
                        children: <div></div>,
                    },
                ]}
            ></Tabs>
        </div>
    );
}
